/**
 * Persistent, unclosable, on every route — the landing page included.
 *
 * Not a legal formality. The app ranks stocks and shows charts, which is a
 * shape people read as a recommendation whatever the labels say. This is the
 * counterweight, and it is deliberately not dismissable — a disclaimer you can
 * close is one that is closed exactly when it matters.
 */
export function Disclaimer() {
  return (
    <footer
      className="border-t mt-8"
      style={{ background: "var(--surface-2)", borderColor: "var(--border)" }}
    >
      <div className="mx-auto max-w-6xl px-4 py-5 text-xs leading-relaxed">
        <p style={{ color: "var(--text-secondary)" }}>
          <strong style={{ color: "var(--text-primary)" }}>This is not investment advice.</strong>{" "}
          Nothing here is a recommendation to buy or sell anything. The scores summarise factor data
          — they are not forecasts, and this model{" "}
          <a
            href="#/backtest"
            className="underline underline-offset-2"
            style={{ color: "var(--series-1)" }}
          >
            did not demonstrate predictive skill when tested
          </a>
          . Markets lose money as readily as they make it. Never invest money you need for near-term
          expenses, and consider talking to a licensed financial advisor before acting on anything
          you see here.
        </p>
        <p className="mt-2" style={{ color: "var(--text-muted)" }}>
          <a href="#/privacy" className="underline underline-offset-2">
            Privacy
          </a>
          {" · "}
          <a
            href="https://github.com/Automate-Pros/stock-market-blitz"
            target="_blank"
            rel="noopener noreferrer"
            className="underline underline-offset-2"
          >
            Source
          </a>
        </p>
      </div>
    </footer>
  );
}
